/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_DefaultInputs */

const cs_pipelines_default = /** @type {(inputs: Pipelines_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výchozí`)
};

const en_pipelines_default = /** @type {(inputs: Pipelines_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

/**
* | output |
* | --- |
* | "Default" |
*
* @param {Pipelines_DefaultInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_default = /** @type {((inputs?: Pipelines_DefaultInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_DefaultInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_default(inputs)
	return cs_pipelines_default(inputs)
});